import React, { useEffect, useState } from "react";
import { useQSMStore } from "../../app/search-results/qsm-store/context";
import { differenceInCalendarDays } from "date-fns";
import { range } from "lodash";
import { useI18next } from "gatsby-plugin-react-i18next";
import { Room } from "../../app/search-results/qsm/room-picker";
import { BookingPackageOption } from "@qite/tide-client";

const ProductIntroRooms: React.FC = () => {
  const [qsmState, qsmDispatch] = useQSMStore();
  const [requestRooms, setRequestRooms] = useState<Room[]>(qsmState?.rooms ?? []);
  const [selectedOption, setSelectedOption] = useState<BookingPackageOption>();
  const { t } = useI18next();

  useEffect(() => {
    const option = qsmState?.bookingPackage?.options.find((x) => x.isSelected);
    setSelectedOption(option);
  }, [qsmState, qsmState?.bookingPackage]);

  useEffect(() => {
    if (qsmState?.rooms) {
      setRequestRooms(qsmState.rooms);
    }
  }, [qsmState?.rooms]);

  return (
    <div className="configure-rooms__frame">
      <div className="configure-rooms__header">
        <div className="configure-rooms__heading">{t("NUMBER_OF_ROOMS")}</div>
        <div className="configure-rooms__actions">
          <div className="decrement-increment">
            <div className="decrement-increment__ui">
              <input
                type="number"
                className="decrement-increment__input"
                value={requestRooms.length ?? 0}
                readOnly
              />
            </div>
          </div>
        </div>
      </div>
      <div className="configure-rooms__body">
        <div className="configure-rooms__groups configure-rooms__groups--product">
          {requestRooms.map((r, index) => (
            <div className="configure-rooms__group" key={index}>
              <div className="configure-rooms__group-header">
                <div className="configure-rooms__group-heading">
                  <h3 className="configure-rooms__group-heading__title">
                    {t("ROOM_X", { roomNumber: index + 1 })}
                  </h3>
                  <span className="configure-rooms__group-heading__subtitle">
                    {qsmState?.bookingRooms && (
                      <>
                        {selectedOption?.rooms[index]?.options[0]?.from &&
                          selectedOption?.rooms[index].options[0]?.to &&
                          t("X_NIGHTS", {
                            numberOfNights: differenceInCalendarDays(
                              new Date(selectedOption?.rooms[index].options[0].to),
                              new Date(selectedOption?.rooms[index].options[0].from)
                            ),
                          })}{" "}
                        {r.accommodationCode
                          ? qsmState?.bookingRooms[index]?.options.find(
                              (o) => o.accommodationCode == r.accommodationCode
                            )?.accommodationName
                          : qsmState?.bookingRooms[index]?.options.find((o) => o.isSelected)
                              ?.accommodationName}
                        {(qsmState?.bookingRooms[index]?.options.find(
                          (o) => o.regimeCode == r.regimeCode
                        )?.regimeName ||
                          qsmState?.bookingRooms[index]?.options.find((o) => o.isSelected)
                            ?.regimeName) && (
                          <>
                            ,&nbsp;
                            {r.regimeCode
                              ? qsmState?.bookingRooms[index]?.options.find(
                                  (o) => o.regimeCode == r.regimeCode
                                )?.regimeName
                              : qsmState?.bookingRooms[index]?.options.find((o) => o.isSelected)
                                  ?.regimeName}
                          </>
                        )}
                      </>
                    )}
                  </span>
                </div>
                <div className="configure-rooms__group-actions">
                  <div className="decrement-increment">
                    <label className="decrement-increment__label">{t("ADULTS")}:</label>
                    <div className="decrement-increment__ui">
                      <input
                        type="number"
                        className="decrement-increment__input"
                        value={r.adults}
                        min={1}
                        readOnly
                      />
                    </div>
                  </div>
                  <div className="decrement-increment">
                    <label className="decrement-increment__label">{t("CHILDREN")}:</label>
                    <div className="decrement-increment__ui">
                      <input
                        type="number"
                        className="decrement-increment__input"
                        value={r.children}
                        readOnly
                      />
                    </div>
                  </div>
                </div>
              </div>
              {requestRooms[index].children > 0 && (
                <div className="configure-rooms__group-children">
                  <label className="room-line__ages-label">
                    {t("AGE_BY_DEPARTURE_DATE")}:&nbsp;
                    {range(0, requestRooms[index].children).map((childIndex, key) => (
                      <span key={key}>
                        {t("X_YEAR", { age: requestRooms[index].childAges[childIndex] })}
                        {childIndex + 1 != requestRooms[index].children ? <>,&nbsp;</> : <></>}
                      </span>
                    ))}
                  </label>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProductIntroRooms;
